import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ErrorMargins} from '../../../models/error-margins.interface';

@Component({
  selector: 'app-error-margins-filter',
  templateUrl: './error-margins-filter.component.html',
  styleUrls: ['./error-margins-filter.component.scss']
})
export class ErrorMarginsFilterComponent implements OnInit {

  keyFigures: string[] = [];
  searchForm = this.formBuilder.group({
    keyFigure: [''],
  });

  get keyFigureControl(): FormControl {
    return this.searchForm.get('keyFigure') as FormControl;
  }

  @Input()
  errors!: ErrorMargins[];

  @Output()
  search: EventEmitter<string> = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.errors.forEach(error => {this.keyFigures.push(error.keyFigures); });
  }

  handleSubmit(): void {
    this.search.emit(this.keyFigureControl.value);
  }

}
